import { useEffect, useRef, useState } from "react";
import { Users, TrendingUp, UserCheck, UserMinus, Gift, Calendar, FileText, IdCard, CheckCircle, Clock, BarChart3, AlertTriangle, } from "lucide-react";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import Skeleton from '@mui/material/Skeleton';
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { TableCard } from "../../../../component/table/table-layout";
import { CustomDropdown } from "../../../../component/ui/dropdown/CustomDropdown";
import { CustomDropdownButton } from "../../../../component/ui/dropdown/CustomDropdownButton";
import { CustomDropdownMenu } from "../../../../component/ui/dropdown/CustomDropdownMenu";
import { CustomDropdownMenuList } from "../../../../component/ui/dropdown/CustomDropdownMenuList";
import WorkForceQuickView from "./popup";
import { Card, CardContent, CardHeader, CardTitle, KPI, TitleHeading } from "../../../../component/ui/layout";
import { FeildWraper, FormArea } from "../../../../component/form/form-layout";
import Picker from "react-month-picker";
import "react-month-picker/css/month-picker.css";
import moment from "moment";

const MONTHS = [
  "Jan", "Feb", "Mar", "Apr",
  "May", "Jun", "Jul", "Aug",
  "Sep", "Oct", "Nov", "Dec"
];

const FULLMONTHS = [
  "",
  "January", "February", "March", "April",
  "May", "June", "July", "August",
  "September", "October", "November", "December"
];

// --- Main Component ---
export default function PPCOrgOverview() {
  // let data = "";
  const apiCall = useApiCall();

  const [dashboardData, setDashboardData] = useState({});
  const [isDashboardApiLoaded, setIsDashboardApiLoaded] = useState(false)

  const [isTrendLoad, setIsTrendLoad] = useState(false)
  const [monthlyTrend, setMonthlyTrend] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(moment(new Date()).format("YYYY-MM"))

  const getDashboardData = async () => {
    setIsDashboardApiLoaded(false);
    try {
      const resp = await apiCall({ method: "get", url: `get-dashboard-data?month=${selectedMonth}` });
      setDashboardData(resp);
      setIsDashboardApiLoaded(true);
    } catch (error) {
      console.warn("Error : ", error);
    }
  }

  const getPerformanceTrend = async () => {
    try {
      const resp = await apiCall({ method: "get", url: `get-monthly-performance-trends?data_type=chart` });
      setMonthlyTrend(resp.data);
      setIsTrendLoad(true);
    } catch (error) {
      console.log("Err", error)
    }
  }

  useEffect(() => {
    
    getPerformanceTrend();
  }, []);

  useEffect(() => {
    getDashboardData();
  }, [selectedMonth])

  // LINE CHART

  const getInitials = (name) => {
    if (!name) return "";
  
    const parts = name.trim().split(" ").filter(Boolean);
  
    if (parts.length === 1) {
      return parts[0][0].toUpperCase();
    }
  
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }


  const lineOptions = {
    chart: { type: "line", backgroundColor: "transparent", height: 450 },
    title: { text: "" },
    xAxis: {
      categories: monthlyTrend?.map((d) => d.month),
      lineColor: "#E5E7EB",
      labels: { style: { color: "#6B7280" } },
    },
    yAxis: {
      title: { text: "Monthly" },
      gridLineColor: "#F3F4F6",
      labels: { style: { color: "#6B7280" } },
    },
    legend: { align: "right", verticalAlign: "top" },
    series: [
      {
        name: "Ad Spend",
        data: monthlyTrend?.map((d) => d.ad_spend),
        // color: "#2563EB",
      },
      {
        name: "Revenue",
        data: monthlyTrend?.map((d) => d.revenue),
        // color: "#1FC16B",
      },
      {
        name: "ROAS",
        data: monthlyTrend?.map((d) => d.roas),
        // color: "#1FC16B",
      },
      {
        name: "Conversions",
        data: monthlyTrend?.map((d) => d.conversions),
        // color: "#1FC16B",
      },
      {
        name: "CPA",
        data: monthlyTrend?.map((d) => d.cpa),
        // color: "#1FC16B",
      },
      {
        name: "Clicks",
        data: monthlyTrend?.map((d) => d.clicks),
        // color: "#1FC16B",
      },
      {
        name: "Impressions",
        data: monthlyTrend?.map((d) => d.impressions),
        // color: "#1FC16B",
      },
      {
        name: "CTR",
        data: monthlyTrend?.map((d) => d.ctr),
        // color: "#1FC16B",
      },
      {
        name: "CPC",
        data: monthlyTrend?.map((d) => d.cpc),
        // color: "#1FC16B",
      },
      {
        name: "Spend MOM",
        data: monthlyTrend?.map((d) => d.spend_mom),
        // color: "#1FC16B",
      },
      {
        name: "Revenue MOM",
        data: monthlyTrend?.map((d) => d.revenue_mom),
        // color: "#1FC16B",
      },
      {
        name: "ROAS MOM",
        data: monthlyTrend?.map((d) => d.roas_mom),
        // color: "#1FC16B",
      },
    ],
    credits: { enabled: false },
  };

  const managerOptions = {
    chart: { type: "line", backgroundColor: "transparent", height: 400 },
    title: { text: "" },
    xAxis: {
      categories: dashboardData?.account_manager_performance?.map((manager) => getInitials(manager?.account_manager)),
      lineColor: "#E5E7EB",
      labels: { style: { color: "#6B7280" } },
    },
    yAxis: {
      title: { text: "Users" },
      gridLineColor: "#F3F4F6",
      labels: { style: { color: "#6B7280" } },
    },
    tooltip: {
      formatter: function () {
        const fullName = dashboardData?.account_manager_performance[this.point.index]?.account_manager || "";
        return `
          <b>${fullName}</b><br/><br/>

          Ad Spend:  <b>${dashboardData?.account_manager_performance[this.point.index]?.spend?.toFixed(2) || ""}</b><br/>
          Revenue:  <b>${dashboardData?.account_manager_performance[this.point.index]?.revenue?.toFixed(2) || ""}</b><br/>
          ROAS:  <b>${dashboardData?.account_manager_performance[this.point.index]?.roas?.toFixed(2) || ""}</b><br/>
          Conversions:  <b>${dashboardData?.account_manager_performance[this.point.index]?.conversions?.toFixed(2) || ""}</b><br/>
          CPL:  <b>${dashboardData?.account_manager_performance[this.point.index]?.cpl?.toFixed(2) || ""}</b><br/>
          Clicks:  <b>${dashboardData?.account_manager_performance[this.point.index]?.clicks?.toFixed(2) || ""}</b><br/>
          Impressions:  <b>${dashboardData?.account_manager_performance[this.point.index]?.impressions?.toFixed(2) || ""}</b><br/>
          CTR:  <b>${dashboardData?.account_manager_performance[this.point.index]?.ctr?.toFixed(2) || ""}</b><br/>
          CPC:  <b>${dashboardData?.account_manager_performance[this.point.index]?.cpc?.toFixed(2) || ""}</b>
        `;
      },
      shared: true
    },
    legend: { align: "right", verticalAlign: "top" },
    series: [
      {
        name: "Ad Spend",
        data: dashboardData?.account_manager_performance?.map((d) => d.spend),
        // color: "#2563EB",
      },
      {
        name: "Revenue",
        data: dashboardData?.account_manager_performance?.map((d) => d.revenue),
        // color: "#1FC16B",
      },
      {
        name: "ROAS",
        data: dashboardData?.account_manager_performance?.map((d) => d.roas),
        // color: "#1FC16B",
      },
      {
        name: "Conversions",
        data: dashboardData?.account_manager_performance?.map((d) => d.conversions),
        // color: "#1FC16B",
      },
      {
        name: "CPL",
        data: dashboardData?.account_manager_performance?.map((d) => d.cpl),
        // color: "#1FC16B",
      },
      {
        name: "Clicks",
        data: dashboardData?.account_manager_performance?.map((d) => d.clicks),
        // color: "#1FC16B",
      },
      {
        name: "Impressions",
        data: dashboardData?.account_manager_performance?.map((d) => d.impressions),
        // color: "#1FC16B",
      },
      {
        name: "CTR",
        data: dashboardData?.account_manager_performance?.map((d) => d.ctr),
        // color: "#1FC16B",
      },
      {
        name: "CPC",
        data: dashboardData?.account_manager_performance?.map((d) => d.cpc),
        // color: "#1FC16B",
      },
    ],
    credits: { enabled: false },
  };

  const [activeChart, setActiveChart] = useState("Service");
  const [activeChart2, setActiveChart2] = useState("Service");

  const serviceOptions = {
    chart: {
      type: "pie",
    },
    title: "none",
    credits: { enabled: false },
    tooltip: {
      formatter: function () {
        const currentItem = dashboardData?.[(activeChart == "Service") ? "performance_by_service" : (activeChart == "Device") ? "performance_by_device" : "performance_by_platform"]?.[this.point.index]
        const fullName = currentItem[(activeChart == "Service") ? "service_name" : (activeChart == "Device") ? "device" : "platform"]
        return `
          <b>${fullName}</b><br/>
          Ad Spend:  <b>${currentItem?.ad_spend || ""}</b><br />
        `;
      },
      // shared: true
    },
    accessibility: {
      point: {
        valueSuffix: "%"
      }
    },
    // plotOptions: {
    //   pie: {
    //     allowPointSelect: true,
    //     cursor: "pointer",
    //     dataLabels: {
    //       enabled: true,
    //       format: "<b>{point.name}</b>: {point.percentage:.1f}% ({point.count})"
    //     }
    //   },
    // },
    series: (activeChart == "Service") ? [
      {
        name: "Ad Spend",
        colorByPoint: true,
        data: dashboardData?.performance_by_service?.map(item => ({
          count: Number(item.ad_spend.replace(/[$,]/g, "")) || 0,
          name: item.service_name,
          y: parseFloat(Number(item.ad_spend.replace(/[$,]/g, "")) || 0)
        }))
      }
    ] : (activeChart == "Device") ? [
      {
        name: "Ad Spend",
        colorByPoint: true,
        data: dashboardData?.performance_by_device?.map(item => ({
          count: Number(item.ad_spend.replace(/[$,]/g, "")) || 0,
          name: item.device,
          y: parseFloat(Number(item.ad_spend.replace(/[$,]/g, "")) || 0)
        }))
      }
    ] : [
      {
        name: "Ad Spend",
        colorByPoint: true,
        data: dashboardData?.performance_by_platform?.map(item => ({
          count: Number(item.ad_spend.replace(/[$,]/g, "")) || 0,
          name: item.platform,
          y: parseFloat(Number(item.ad_spend.replace(/[$,]/g, "")) || 0)
        }))
      }
    ],
    // series: [
    //   {
    //     name: "Employees",
    //     colorByPoint: true,
    //     data: Object.entries(pieData)?.map(([key, val]) => ({
    //       count: val,
    //       name: key.replaceAll("_", " "),
    //       y: parseFloat(val)
    //     }))
    //   }
    // ],
    legend: { enabled: false },
  };

  const serviceOptions2 = {
    chart: {
      type: "pie",
    },
    title: "none",
    credits: { enabled: false },
    // tooltip: {
    //   pointFormat: "{series.name}: <b>{point.count}</b><br/>Percentage: <b>{point.percentage:.1f}%</b>"
    // },
    tooltip: {
      formatter: function () {
        // const fullName = dashboardData?.account_manager_performance[this.point.index]?.account_manager || "";
        const currentItem = dashboardData?.[(activeChart2 == "Service") ? "performance_by_service" : (activeChart2 == "Device") ? "performance_by_device" : "performance_by_platform"]?.[this.point.index]
        const fullName = currentItem[(activeChart2 == "Service") ? "service_name" : (activeChart2 == "Device") ? "device" : "platform"]
        return `
          <b>${fullName}</b><br/>
          Revenue:  <b>${currentItem?.revenue || ""}</b><br />
        `;
      },
      shared: true
    },
    accessibility: {
      point: {
        valueSuffix: "%"
      }
    },
    // plotOptions: {
    //   pie: {
    //     allowPointSelect: true,
    //     cursor: "pointer",
    //     dataLabels: {
    //       enabled: true,
    //       format: "<b>{point.name}</b>: {point.percentage:.1f}% ({point.count})"
    //     }
    //   },
    // },
    series: (activeChart2 == "Service") ? [
      {
        name: "Revenue",
        colorByPoint: true,
        data: dashboardData?.performance_by_service?.map(item => ({
          count: Number(item.revenue.replace(/[$,]/g, "")) || 0,
          name: item.service_name,
          y: parseFloat(Number(item.revenue.replace(/[$,]/g, "")) || 0)
        }))
      }
    ] : (activeChart2 == "Device") ? [
      {
        name: "Revenue",
        colorByPoint: true,
        data: dashboardData?.performance_by_device?.map(item => ({
          count: Number(item.revenue.replace(/[$,]/g, "")) || 0,
          name: item.device,
          y: parseFloat(Number(item.revenue.replace(/[$,]/g, "")) || 0)
        }))
      }
    ] : [
      {
        name: "Revenue",
        colorByPoint: true,
        data: dashboardData?.performance_by_platform?.map(item => ({
          count: Number(item.revenue.replace(/[$,]/g, "")) || 0,
          name: item.platform,
          y: parseFloat(Number(item.revenue.replace(/[$,]/g, "")) || 0)
        }))
      }
    ],
    // series: [
    //   {
    //     name: "Employees",
    //     colorByPoint: true,
    //     data: Object.entries(pieData)?.map(([key, val]) => ({
    //       count: val,
    //       name: key.replaceAll("_", " "),
    //       y: parseFloat(val)
    //     }))
    //   }
    // ],
    legend: { enabled: false },
  };

  const [showWorkForce, setShowWorkForce] = useState(false);
  const [popupData, setPopupData] = useState({});

  const pickerRef = useRef(null);
  const handleChange = (year, month) => {
    setSelectedMonth(`${year}-${month}`)
    pickerRef.current.dismiss();
  };

  // function PriorityBadge({ p, title }) {
  //   const cls =
  //     p === 0
  //       ? "bg-red-100 text-red-700"
  //       : p === 1
  //       ? "bg-amber-100 text-amber-700"
  //       : "bg-emerald-100 text-emerald-700";
  
  //   return (
  //     <span className={`text-[12px] px-2 py-1 rounded-full font-semibold ${cls}`}>
  //       {title}
  //     </span>
  //   );
  // }

  // function PriorityBadge({ p, title }) {
  //   const cls =
  //     p === 0
  //       ? "bg-slate-100 text-slate-700"
  //       : p === 1
  //       ? "bg-sky-100 text-sky-700"
  //       : "bg-violet-100 text-violet-700";
  
  //   return (
  //     <span className={`text-[12px] px-2 py-1 rounded-full font-semibold ${cls}`}>
  //       {title}
  //     </span>
  //   );
  // }

  // function PriorityBadge({ p, title }) {
  //   const cls =
  //     p === 0
  //       ? "bg-blue-100 text-blue-700"
  //       : p === 1
  //       ? "bg-indigo-100 text-indigo-700"
  //       : "bg-teal-100 text-teal-700";
  
  //   return (
  //     <span className={`text-[12px] px-2 py-1 rounded-full font-semibold ${cls}`}>
  //       {title}
  //     </span>
  //   );
  // }

  function PriorityBadge({ p, title }) {
    const colors = [
      "text-cyan-700",
      "text-fuchsia-700",
      "text-lime-700",
      "text-sky-700",
      "text-teal-700"
    ]
  
    return (
      <span className={`text-[12px] px-2 py-1 rounded-full font-semibold ${colors[p]}`}>
        {title}
      </span>
    );
  }

  return (
    <>
      <div className="pt-[10px] overflow-hidden">
        <div className="w-full h-full overflow-hidden flex flex-col gap-[10px]">
          {/* Header */}
          <div className="flex items-center justify-between">
            <TitleHeading>PPC Overview</TitleHeading>
            <div className="">
              <FeildWraper className={"!w-full"}>
                {/* <input type="month" className="w-[200px]" max={moment(new Date()).format("YYYY-MM")} value={selectedMonth} onChange={(e) => {setSelectedMonth(e.target.value)}} /> */}
                <Picker
                  ref={pickerRef}
                  years={{min: {year: 1900}, max: {year: new Date().getFullYear(), month: new Date().getMonth() + 1} }}
                  value={selectedMonth ? {month: Number(selectedMonth?.split("-")?.[1]), year: Number(selectedMonth?.split("-")?.[0])}: {}}
                  onChange={handleChange}
                  lang={MONTHS}
                >
                  <button
                    type="button"
                    onClick={() => pickerRef.current.show()}
                    className="flex w-[165px] items-center gap-3 justify-between bg-white border relative border-[#dfdfdf] rounded-[5px] text-[#1e1e1e] font-inter text-[14px] font-medium h-[35px] leading-none px-[14px]"
                  >
                    <div className="">
                      {/* {FULLMONTHS[value?.month]} {value?.year} */}
                      {moment(selectedMonth, "YYYY-MM").format("MMMM YYYY")}
                    </div>
                    <div className="">
                      <Calendar className="h-[14px] w-[14px]" />
                    </div>
                  </button>
                </Picker>
              </FeildWraper>
            </div>
          </div>

          {/* KPI Row */}
          <TableCard className={"!p-[15px] !pr-[7px] h-full overflow-hidden"}>
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 lg:grid-rows-2 gap-4">
              {isDashboardApiLoaded ? (
                <>
                  {/* {dashboardData?.overall_performance?.map((eachKpi, i) => (
                    <KPI
                      icon={Users}
                      label={eachKpi?.title}
                      value={eachKpi?.this}
                      sublabel={`Previous Month: ${eachKpi?.last}`}
                      stateLable={`${eachKpi?.mom_change?.replace("-", "")}`}
                      positive={!eachKpi?.mom_change.includes("-")}
                    />
                  ))} */}
                  <div className="row-span-2 col-span-2 flex flex-col gap-4">
                    <KPI
                      // className={"h-full flex flex-col justify-between"}
                      icon={Users}
                      extraClass={"theme"}
                      label={dashboardData?.kpi_cards?.total_ad_spend?.title}
                      value={dashboardData?.kpi_cards?.total_ad_spend?.this}
                      sublabel={`Previous Month: ${dashboardData?.kpi_cards?.total_ad_spend?.last}`}
                      stateLable={`${dashboardData?.kpi_cards?.total_ad_spend?.mom_change?.replace("-", "")}`}
                      positive={!dashboardData?.kpi_cards?.total_ad_spend?.mom_change.includes("-")}
                     
                    />
                    <div className="flex items-center gap-[16px]">
                      <div className="w-[calc((100%-16px)/2)]">
                        <KPI
                          icon={Users}
                          label={dashboardData?.kpi_cards?.total_revenue?.title}
                          value={dashboardData?.kpi_cards?.total_revenue?.this}
                          sublabel={`Previous Month: ${dashboardData?.kpi_cards?.total_revenue?.last}`}
                          stateLable={`${dashboardData?.kpi_cards?.total_revenue?.mom_change?.replace("-", "")}`}
                          positive={!dashboardData?.kpi_cards?.total_revenue?.mom_change.includes("-")}
                        />
                      </div>

                      <div className="w-[calc((100%-16px)/2)]">
                        <KPI
                          icon={Users}
                          label={dashboardData?.kpi_cards?.roas?.title}
                          value={dashboardData?.kpi_cards?.roas?.this}
                          sublabel={`Previous Month: ${dashboardData?.kpi_cards?.roas?.last}`}
                          stateLable={`${dashboardData?.kpi_cards?.roas?.mom_change?.replace("-", "")}`}
                          positive={!dashboardData?.kpi_cards?.roas?.mom_change.includes("-")}
                          extraClass={dashboardData?.kpi_cards?.roas?.status == "bad" ? "yellow" : "green"}
                        />
                      </div>

                    </div>
                  </div>

                  {dashboardData?.performance_by_service?.map((eachKpi, i) => (
                    <div className="row-span-2 flex flex-col gap-4">
                      <KPI
                        // icon={Users}
                        label={`Ad Spend`}
                        value={eachKpi?.ad_spend}
                        Status={<PriorityBadge p={i} title={eachKpi?.service_name} />}
                        // sublabel={`Ad Spend`}
                        sublabel={`Previous Month: ${eachKpi?.last_ad_spend}`}
                        stateLable={`${eachKpi?.mom ? eachKpi?.mom?.replace("-", "") : ""}`}
                        positive={(eachKpi?.mom != "-" && !eachKpi?.mom.includes("-"))}
                      />
                      <KPI
                        // icon={Users}
                        Status={<PriorityBadge p={i} title={eachKpi?.service_name} />}
                        label={`Revenue`}
                        value={eachKpi?.revenue}
                        // sublabel={`Revenue`}
                        sublabel={`Previous Month: ${eachKpi?.last_revenue}`}
                        stateLable={`${eachKpi?.revenue_mom ? eachKpi?.revenue_mom?.replace("-", "") : ""}`}
                        positive={(eachKpi?.revenue_mom != "-" && !eachKpi?.revenue_mom.includes("-"))}
                      />
                    </div>
                  ))}

                  {dashboardData?.performance_by_platform?.length ?
                    <div className="row-span-2 flex flex-col gap-4">
                      <KPI
                        // icon={Users}
                        Status={<PriorityBadge p={3} title={dashboardData?.performance_by_platform[0]?.platform} />}
                        label={`Ad Spend`}
                        value={dashboardData?.performance_by_platform[0]?.ad_spend}
                        // sublabel={`Ad Spend`}
                        sublabel={`Previous Month: ${dashboardData?.performance_by_platform[0]?.last_ad_spend}`}
                        stateLable={`${dashboardData?.performance_by_platform[0]?.mom ? dashboardData?.performance_by_platform[0]?.mom?.replace("-", "") : ""}`}
                        positive={(dashboardData?.performance_by_platform[0]?.mom != "-" && !dashboardData?.performance_by_platform[0]?.mom.includes("-"))}
                      />
                      <KPI
                        // icon={Users}
                        Status={<PriorityBadge p={4} title={dashboardData?.performance_by_platform[dashboardData?.performance_by_platform?.length - 1]?.platform} />}
                        label={`Ad Spend`}
                        value={dashboardData?.performance_by_platform[dashboardData?.performance_by_platform?.length - 1]?.ad_spend}
                        // sublabel={`Ad Spend`}
                        sublabel={`Previous Month: ${dashboardData?.performance_by_platform[dashboardData?.performance_by_platform?.length - 1]?.last_ad_spend}`}
                        stateLable={`${dashboardData?.performance_by_platform[dashboardData?.performance_by_platform?.length - 1]?.mom ? dashboardData?.performance_by_platform[dashboardData?.performance_by_platform?.length - 1]?.mom?.replace("-", "") : ""}`}
                        positive={(dashboardData?.performance_by_platform[dashboardData?.performance_by_platform?.length - 1]?.mom != "-" && !dashboardData?.performance_by_platform[dashboardData?.performance_by_platform?.length - 1]?.mom.includes("-"))}
                      />
                    </div>
                    :
                    null
                  }

                  {/* <div className="row-span-2 flex flex-col gap-4">
                    <KPI
                      icon={Users}
                      label={`${dashboardData?.performance_by_platform[dashboardData?.performance_by_platform?.length - 1]?.platform}'s Ad Spend`}
                      value={dashboardData?.performance_by_platform[dashboardData?.performance_by_platform?.length - 1]?.ad_spend}
                      sublabel={`Ad Spend`}
                    />
                    <KPI
                      icon={Users}
                      label={`${dashboardData?.performance_by_platform[dashboardData?.performance_by_platform?.length - 1]?.platform}'s Revenue`}
                      value={dashboardData?.performance_by_platform[dashboardData?.performance_by_platform?.length - 1]?.revenue}
                      sublabel={`Revenue`}
                    />
                  </div> */}


                </>
              ) : (
                Array.from({ length: 12 }).map((_, index) => (
                  <div key={index} className="bg-white shadow rounded-xl p-4 animate-pulse">
                    {/* Top row: label + icon */}
                    <div className="flex items-center justify-between mb-2">
                      <Skeleton variant="text" width={80} height={16} />
                      <Skeleton variant="circular" width={20} height={20} />
                    </div>
                    {/* Value row */}
                    <div className="flex items-center justify-between gap-2 mb-1">
                      <Skeleton variant="text" width={60} height={32} />
                      <Skeleton variant="rounded" width={40} height={20} />
                    </div>
                    {/* Sublabel */}
                    <Skeleton variant="text" width={80} height={12} />
                  </div>
                ))
              )}
            </div>

            {/* <div className="my-6">
              <TitleHeading>Product Overview</TitleHeading>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
              {isDashboardApiLoaded ? (
                <>
                  {dashboardData?.performance_by_service?.map((eachKpi, i) => (
                    <>
                      <KPI
                        icon={Users}
                        label={`${eachKpi?.service_name}'s Ad Spend`}
                        value={eachKpi?.ad_spend}
                        sublabel={`Ad Spend`}
                        // stateLable={`${eachKpi?.mom_change?.replace("-", "")}`}
                        // positive={!eachKpi?.mom_change.includes("-")}
                        // onClick={() => {
                        //   setPopupData({
                        //     apiKey: "active_users",
                        //     apiUrl: "get-all-employees",
                        //     pagUrl: "/employee/directory/employees",
                        //     title: `Workforce (${KPIData?.active_employees})`,
                        //     subTitle: `Active Employees`,
                        //     icon: <Users />,
                        //   });
                        //   setShowWorkForce(true);
                        // }}
                      />
                      <KPI
                        icon={Users}
                        label={`${eachKpi?.service_name}'s Revenue`}
                        value={eachKpi?.revenue}
                        sublabel={`Revenue`}
                        // stateLable={`${eachKpi?.mom_change?.replace("-", "")}`}
                        // positive={!eachKpi?.mom_change.includes("-")}
                        // onClick={() => {
                        //   setPopupData({
                        //     apiKey: "active_users",
                        //     apiUrl: "get-all-employees",
                        //     pagUrl: "/employee/directory/employees",
                        //     title: `Workforce (${KPIData?.active_employees})`,
                        //     subTitle: `Active Employees`,
                        //     icon: <Users />,
                        //   });
                        //   setShowWorkForce(true);
                        // }}
                      />
                    </>
                  ))}
                </>
              ) : (
                Array.from({ length: 6 }).map((_, index) => (
                  <div key={index} className="bg-white shadow rounded-xl p-4 animate-pulse">
                    <div className="flex items-center justify-between mb-2">
                      <Skeleton variant="text" width={80} height={16} />
                      <Skeleton variant="circular" width={20} height={20} />
                    </div>
                    <div className="flex items-center justify-between gap-2 mb-1">
                      <Skeleton variant="text" width={60} height={32} />
                      <Skeleton variant="rounded" width={40} height={20} />
                    </div>
                    <Skeleton variant="text" width={80} height={12} />
                  </div>
                ))
              )}
            </div> */}

            <div className="grid grid-cols-1 md:grid-cols-6 gap-6 mt-6">

              {/* Line Chart */}

              <Card className="col-span-4 min-h-[500px]">
                <CardHeader className="flex items-center justify-between">
                  <CardTitle className="flex items-center gap-2">
                    <TrendingUp className="h-5 w-5" /> Account Manager Performance
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  {
                    isDashboardApiLoaded ? (
                      <HighchartsReact highcharts={Highcharts} options={managerOptions} />
                    ) : (
                      <InnerLoader />
                    )
                  }
                </CardContent>
              </Card>

              <Card className="col-span-2 min-h-[500px]">
                <CardHeader className="flex items-center justify-between">
                  <CardTitle className="flex items-center gap-2">
                    <BarChart3 className="h-5 w-5" />
                    <CustomDropdown
                      position="bottom-right"
                      className="myDropdown"
                    >
                      <CustomDropdownButton arrow={true} className="btnClass">
                        <h3 className="!text-[16px]">Spend By {activeChart}</h3>
                      </CustomDropdownButton>

                      <CustomDropdownMenu className="w-full">
                        {activeChart != "Service" && (
                          <CustomDropdownMenuList
                            onClick={() => {
                              setActiveChart("Service");
                            }}
                          >
                            <div
                              className={
                                "d-flex whitespace-normal align-items-center gap-1"
                              }
                            >
                              Spend By Service
                            </div>
                          </CustomDropdownMenuList>
                        )}
                        {activeChart != "Device" && (
                          <CustomDropdownMenuList
                            onClick={() => {
                              setActiveChart("Device");
                            }}
                          >
                            <div
                              className={
                                "d-flex whitespace-normal align-items-center gap-1"
                              }
                            >
                              Spend By Device
                            </div>
                          </CustomDropdownMenuList>
                        )}
                        {activeChart != "Platform" && (
                          <CustomDropdownMenuList
                            onClick={() => {
                              setActiveChart("Platform");
                            }}
                          >
                            <div
                              className={
                                "d-flex whitespace-normal align-items-center gap-1"
                              }
                            >
                              Spend By Platform
                            </div>
                          </CustomDropdownMenuList>
                        )}
                      </CustomDropdownMenu>
                    </CustomDropdown>
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  {
                    isDashboardApiLoaded ? (
                      <HighchartsReact highcharts={Highcharts} options={serviceOptions} />
                    ) : (
                      <InnerLoader />
                    )
                  }
                </CardContent>
              </Card>

              {/* Donut Chart */}
              {/* <Card className="col-span-2 min-h-[500px]">
                <CardHeader className="flex items-center justify-between">
                  <CardTitle className="flex items-center gap-2">
                    <BarChart3 className="h-5 w-5" /> Performance By Device
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  {
                    isDashboardApiLoaded ? (
                      <HighchartsReact highcharts={Highcharts} options={deviceOptions} />
                    ) : (
                      <InnerLoader />
                    )
                  }
                </CardContent>
              </Card> */}


              {/* Bar Chart */}
              <Card className="col-span-4 min-h-[500px]">
                <CardHeader className="flex items-center justify-between">
                  <CardTitle className="flex items-center gap-2">
                    <TrendingUp className="h-5 w-5" /> Monthly Trends
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  {
                    isTrendLoad ? (
                      <HighchartsReact highcharts={Highcharts} options={lineOptions} />
                    ) : (
                      <InnerLoader />
                    )
                  }
                </CardContent>
              </Card>

              <Card className="col-span-2 min-h-[500px]">
                <CardHeader className="flex items-center justify-between">
                  <CardTitle className="flex items-center gap-2">
                    <BarChart3 className="h-5 w-5" />
                    <CustomDropdown
                      position="bottom-right"
                      className="myDropdown"
                    >
                      <CustomDropdownButton arrow={true} className="btnClass">
                        <h3 className="!text-[16px]">Revenue By {activeChart2}</h3>
                      </CustomDropdownButton>

                      <CustomDropdownMenu className="w-full">
                        {activeChart2 != "Service" && (
                          <CustomDropdownMenuList
                            onClick={() => {
                              setActiveChart2("Service");
                            }}
                          >
                            <div
                              className={
                                "d-flex whitespace-normal align-items-center gap-1"
                              }
                            >
                              Revenue By Service
                            </div>
                          </CustomDropdownMenuList>
                        )}
                        {activeChart2 != "Device" && (
                          <CustomDropdownMenuList
                            onClick={() => {
                              setActiveChart2("Device");
                            }}
                          >
                            <div
                              className={
                                "d-flex whitespace-normal align-items-center gap-1"
                              }
                            >
                              Revenue By Device
                            </div>
                          </CustomDropdownMenuList>
                        )}
                        {activeChart2 != "Platform" && (
                          <CustomDropdownMenuList
                            onClick={() => {
                              setActiveChart2("Platform");
                            }}
                          >
                            <div
                              className={
                                "d-flex whitespace-normal align-items-center gap-1"
                              }
                            >
                              Revenue By Platform
                            </div>
                          </CustomDropdownMenuList>
                        )}
                      </CustomDropdownMenu>
                    </CustomDropdown>
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  {
                    isDashboardApiLoaded ? (
                      <HighchartsReact highcharts={Highcharts} options={serviceOptions2} />
                    ) : (
                      <InnerLoader />
                    )
                  }
                </CardContent>
              </Card>

              {/* Pie Chart */}
            </div>
          </TableCard>
        </div>
      </div>

      {showWorkForce && (
        <WorkForceQuickView
          onClose={() => setShowWorkForce(false)}
          apiKey={popupData.apiKey}
          apiUrl={popupData.apiUrl}
          pagUrl={popupData.pagUrl}
          title={popupData.title}
          subTitle={popupData.subTitle}
          icon={popupData.icon}
          positive={popupData?.positive}
          stateLable={popupData?.stateLable}
          positiveIcon={popupData?.positiveIcon}
        />
      )}
    </>
  );
}
